import { gql, WatchQueryFetchPolicy } from '@apollo/client';

const scenarioInputFields = `
numberOfAcademicStaff
  numberOfAcademicStaffOfInternationalOrOverseasOrigin
  numberOfResearchStaff
  totalNumberOfStudents
  totalNumberOfStudentsOfInternationalOrOverseasOrigin
  totalNumberOfOutboundExchangeStudents
  numberOfUndergraduateDegreesAwarded
  numberOfDoctoratesAwarded
  numberOfResearchDoctoratesAwarded
  numberOfProfessionalDoctoratesAwarded
  totalInstitutionalIncome
  researchIncome
  researchIncomeFromIndustryAndCommerce
  totalPublications
  internationalPublications
  researchVotes
  teachingVotes
  citationScoreCnNormalised
  citationScoreNormalised
  percentileFieldWeightedCitationImpact
  numberOfPublicationsInTheTop10Percentile
  influenceOfPublications
  numberOfPatentsCitingResearch
`;

const scenatioResults = `
  t1
  t2
  t3
  t4
  t5
  r1
  r2
  r3
  c1
  c2
  c3
  c4
  e1
  e2
  i1
  i2
  i3
  i4
`;

export const getScenarioQuery = gql`
  query Scenario(
    $scenarioId: String!
    $institutionId: String!
    $allowScoresForExcluded: Boolean!
  ) {
    scenario(
      institutionId: $institutionId
      scenarioId: $scenarioId
      allowScoresForExcluded: $allowScoresForExcluded
    ) {
      scenarioId
      name
      methodology
      createdAt
      updatedAt
      submissionYear
      publicationYear
      institution {
        id
        country
        currencyCode
      }
      scenarioInputs {
        overall {
          applicable
          ${scenarioInputFields}
        }
        artsAndHumanities {
          applicable
          ${scenarioInputFields}
        }
        businessAndEconomics {
          applicable
          ${scenarioInputFields}
        }
        clinicalAndHealth {
          applicable
          ${scenarioInputFields}
        }
        computerScience {
          applicable
          ${scenarioInputFields}
        }
        education {
          applicable
          ${scenarioInputFields}
        }
        engineering {
          applicable
          ${scenarioInputFields}
        }
        law {
          applicable
          ${scenarioInputFields}
        }
        lifeSciences {
          applicable
          ${scenarioInputFields}
        }
        physicalSciences {
          applicable
          ${scenarioInputFields}
        }
        psychology {
          applicable
          ${scenarioInputFields}
        }
        socialSciences {
          applicable
          ${scenarioInputFields}
        }
      }
      alexanderJson {
        overall {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        artsAndHumanities {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        businessAndEconomics {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        clinicalAndHealth {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        computerScience {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        education {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        engineering {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        law {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        lifeSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        physicalSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        psychology {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        socialSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
      }
    }
  }
`;

export const getWurReporterInterimScenarioQuery = gql`
  query WurReporterInterimScenario(
    $scenarioId: String!
    $institutionId: String!
    $allowScoresForExcluded: Boolean!
  ) {
    wurReporterInterimScenario(
      institutionId: $institutionId
      scenarioId: $scenarioId
      allowScoresForExcluded: $allowScoresForExcluded
    ) {
      scenarioId
      name
      methodology
      createdAt
      updatedAt
      submissionYear
      publicationYear
      institution {
        id
        country
        currencyCode
      }
      scenarioInputs {
        overall {
          applicable
          ${scenarioInputFields}
        }
        artsAndHumanities {
          applicable
          ${scenarioInputFields}
        }
        businessAndEconomics {
          applicable
          ${scenarioInputFields}
        }
        clinicalAndHealth {
          applicable
          ${scenarioInputFields}
        }
        computerScience {
          applicable
          ${scenarioInputFields}
        }
        education {
          applicable
          ${scenarioInputFields}
        }
        engineering {
          applicable
          ${scenarioInputFields}
        }
        law {
          applicable
          ${scenarioInputFields}
        }
        lifeSciences {
          applicable
          ${scenarioInputFields}
        }
        physicalSciences {
          applicable
          ${scenarioInputFields}
        }
        psychology {
          applicable
          ${scenarioInputFields}
        }
        socialSciences {
          applicable
          ${scenarioInputFields}
        }
      }
      alexanderJson {
        overall {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        artsAndHumanities {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        businessAndEconomics {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        clinicalAndHealth {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        computerScience {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        education {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        engineering {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        law {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        lifeSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        physicalSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        psychology {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
        socialSciences {
          applicable
          ${scenatioResults}
          scoreNumber
          scoreDisplay
          rankNumber
          rankDisplay
          exclusions
        }
      }
    }
  }
`;

export const getWurQuery = gql`
  query GetWURRatingAndScore($year: Int!, $institutionId: String!) {
    wurRelease(year: $year) {
      subject(name: "overall") {
        result(institutionId: $institutionId) {
          score {
            higher
            lower
          }
          rank {
            higher
            lower
          }
        }
      }
    }
  }
`;

export const scenarioQueryVariables = (
  scenarioId: string,
  institutionId: string,
  allowScoresForExcluded: boolean,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-first',
) => ({
  fetchPolicy,
  skip: !scenarioId,
  variables: {
    scenarioId,
    institutionId,
    allowScoresForExcluded,
  },
});

export const wurQueryVariables = (year: number, institutionId: string) => ({
  variables: {
    year,
    institutionId,
  },
});
